module.exports = __webpack_public_path__ + "img/cicle-add-icon.8442e288.svg";